<template>
  <div>
    <Head title="Update Channel Price" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/channel-pricings">Channel Prices</Link>
      <span class="text-orange-400 font-medium">/</span> Edit
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-2 pr-6 w-full lg:w-full">Part Number:</div>
          <div class="pb-8 pr-6 w-full lg:w-full">
            <multiselect
              id="part_number"
              v-model="sku_id"
              placeholder="Search SKU"
              :options="skus"
              :close-on-select="true"
              :searchable="true"
              :error="form.errors.sku_id"
              :style="form.errors.sku_id ? 'border: var(--ms-border-width,1px) solid var(--ms-border-color,red)' : ''"
              @search-change="onSearchSkusChange"
              @input="onSelectedSku"
            />
          </div>
  
          <select-input v-model="form.channel_id" :error="form.errors.channel_id" class="pb-8 pr-6 w-full lg:w-full" label="Channel">
            <option :value="null">
              Select Channel
            </option>
            <option
              v-for="channel in channels"
              :key="channel.id"
              :value="channel.id"
            >
              {{ channel.name }}
            </option>
          </select-input>
          <text-input v-model="form.price_exclusive" :error="form.errors.price_exclusive" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Price VAT exclusive" />
          <text-input v-model="form.price_inclusive" :error="form.errors.price_inclusive" class="pb-8 pr-6 w-1/2 lg:w-1/2" label="Price VAT inclusive" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-orange" type="submit">Update</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
    
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Multiselect from '@vueform/multiselect'
import throttle from 'lodash/throttle'
    
export default {
  components: {
    Head,
    Link,
    SelectInput,
    LoadingButton,
    TextInput,
    Multiselect,
  },
  layout: Layout,
  remember: 'form',
  props: {
    channels: Object,
    skus: Object,
    pricing: Object,
  },
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        sku_id: this.pricing.sku_id,
        channel_id: this.pricing.channel_id,
        price_exclusive: this.pricing.price_exclusive,
        price_inclusive: this.pricing.price_inclusive,
      }),
    }
  },
  methods: {
    update() {
      this.form.post(`/channel-pricings/${this.pricing.id}`, this.form)
    },
    onSearchSkusChange: throttle(function (search) {
      this.$inertia.get('/channel-pricings/create', {search}, {
        preserveState: true,
        preserveScroll: true,
        replace: true,
      })
    }, 200),
    onSelectedSku(part_number, id) {
      this.form.sku_id = part_number
    },
  },
}
</script>
  <style src="@vueform/multiselect/themes/default.css"></style>
  <style type="text/css">
    .multiselect-option.is-selected.is-pointed {
      background: var(--ms-option-bg-selected-pointed,#fb923c);
      color: var(--ms-option-color-selected-pointed,#fff);
    }
    .multiselect-option.is-selected {
      background: var(--ms-option-bg-selected-pointed,#fb923c);
      color: var(--ms-option-color-selected-pointed,#fff);
    }
  </style>
  